class OrderHistory {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  vin = "";
  VehicleType = "";
  VehicleTypeId = "";
  loading = false;
  finished = false;
  page = 0;
  count = 0;

  constructor() {}

  setVinInfo({ vin, VehicleType, VehicleTypeId }) {
    this.vin = vin;
    this.VehicleType = VehicleType;
    this.VehicleTypeId = VehicleTypeId;
  }
}
export default new OrderHistory();
